var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46021 4.97917L5.68833 8.2075C5.89611 8.41514 6 8.655 6 8.92708C6 9.19917 5.89611 9.43903 5.68833 9.64667C5.48069 9.85444 5.24083 9.95833 4.96875 9.95833C4.69667 9.95833 4.45444 9.85215 4.24208 9.63979L0.3025 5.70021C0.209583 5.6016 0.135903 5.48896 0.0814584 5.36229C0.0271529 5.23549 0 5.10639 0 4.975C0 4.84361 0.0271529 4.71451 0.0814584 4.58771C0.135903 4.46104 0.209583 4.35118 0.3025 4.25813L4.24208 0.318541C4.45444 0.10618 4.69667 0 4.96875 0C5.24083 0 5.48069 0.103889 5.68833 0.311667C5.89611 0.519306 6 0.759167 6 1.03125C6 1.30333 5.89611 1.54319 5.68833 1.75083L2.46021 4.97917Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.7acc40bafcae7b5e7276765fe1d4834a.svg";
export { ForwardRef as ReactComponent };